module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"add_payment":"إضافة دفعة","add_item":"إضافة منتج","edit_order":"تحرير الطلبية","new_order":"طلبية جديدة","save_order_info":"حفظ معطيات الطالب","add_itemline":"إضافة منتج"},"he":{"edit_order":"עריכת הזמנה","edit_price_quote":"עריכת הצעת מחיר","save_order_info":"שמירת השמנה"}}')
  delete Component.options._Ctor
}
